import { NgTemplateOutlet } from "@angular/common";
import { Component, Input, TemplateRef } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";

@Component({
    selector: "app-show-more",
    imports: [NgTemplateOutlet, TranslateModule],
    templateUrl: "./show-more.component.html",
})
export class ShowMoreComponent {
    @Input() template: TemplateRef<any>;
    @Input() list: Array<any>;
    @Input() limit = 3;

    showAll = false;

    toggle() {
        this.showAll = !this.showAll;
    }
}
